import React, { useEffect } from 'react';

import energyIcon from 'assets/pics/energy_icon.svg';
import gasIcon from 'assets/pics/gas_icon.svg';
import { useNESteps } from 'context/NEStepsContext';
import { useFormik } from 'formik';

import { FormActionButtons } from 'components/FormHelper/FormActionButtons';
import { InputRow } from 'components/FormHelper/InputRow';
import { LabelCheckbox } from 'components/LabelCheckbox/LabelCheckbox';
import {
  NE_CURRENT_TEST_SUITE,
  shouldFillNETestData,
} from 'components/NEForm/NETestdata/NETestSetup';
import { YNEBranchSelectionValidation } from 'components/NEValidation/NEBranchSelectionValidation';

import { BRANCH_TYPE, NE_ACTIVE_STEP, TENANT_ID } from 'global/constants';

import { FFormDebug } from 'utils/FFormDebug';
import { getTenantId } from 'utils/tenantUtil';

import { NEBranchInformation } from './NEBranchInformation';

import './NEStepBranchSelection.sass';

export const NEStepBranchSelection = () => {
  const {
    activeStep,
    setActiveStep,
    setSubmittedValuesWithStep,
    getSubmittedValuesWithStep,
    clearSubmittedValuesWithStep,
  } = useNESteps();
  const formik = useFormik({
    initialValues: shouldFillNETestData
      ? NE_CURRENT_TEST_SUITE.step1
      : {
          isEnergyActive: false,
          isGasActive: false,
          companyTypeEnergy: '',
          companyTypeGas: '',
          branchTypeEnergy: '',
          branchTypeGas: '',
        },
    validationSchema: YNEBranchSelectionValidation,
    validateOnMount: true,
    enableReinitialize: true,
    validateOnChange: true,
  });

  useEffect(() => {
    if (formik.values.isEnergyActive === false) {
      formik.setFieldValue('companyTypeEnergy', '');
      formik.setFieldValue('branchTypeEnergy', '');
    }
    if (formik.values.isGasActive === false) {
      formik.setFieldValue('companyTypeGas', '');
      formik.setFieldValue('branchTypeGas', '');
    }
  }, [formik.values.isEnergyActive, formik.values.isGasActive]);

  if (activeStep !== NE_ACTIVE_STEP.BRANCH_SELECTION) return null;

  const onBack = () => {
    setActiveStep(NE_ACTIVE_STEP.EMAIL_INPUT);
  };

  const onSubmit = () => {
    const currentContextValues = getSubmittedValuesWithStep(NE_ACTIVE_STEP.BRANCH_SELECTION);
    const { values } = formik;
    const valuesChanged = Object.keys(values).some(
      (key) => values[key] !== currentContextValues[key]
    );

    if (valuesChanged) {
      clearSubmittedValuesWithStep(NE_ACTIVE_STEP.FORM);
      setSubmittedValuesWithStep(NE_ACTIVE_STEP.BRANCH_SELECTION, formik.values);
    }

    setActiveStep(NE_ACTIVE_STEP.FORM);
  };

  const getErrorMessage = () => {
    if (formik.errors.noBranchSelected) return formik.errors.noBranchSelected;
    if (!formik.isValid) return 'Füllen Sie das Formular vollständig aus';
    return '';
  };

  return (
    <>
      <div className="ne-step-branch-selection">
        <div className="ne-step-branch-selection-hero">Bitte wählen Sie Ihre Sparte(n) aus:</div>
        <InputRow>
          <LabelCheckbox
            label="Strom"
            id="isEnergyActive"
            name="isEnergyActive"
            error={Boolean(formik.errors?.noBranchSelected)}
            icon={energyIcon}
            value={formik.values.isEnergyActive}
            onChange={formik.handleChange}
          />
          {getTenantId() !== TENANT_ID.LVN && (
            <LabelCheckbox
              label="Gas"
              id="isGasActive"
              name="isGasActive"
              error={Boolean(formik.errors?.noBranchSelected)}
              icon={gasIcon}
              value={formik.values.isGasActive}
              onChange={formik.handleChange}
            />
          )}
        </InputRow>
        {formik.values.isEnergyActive ? (
          <NEBranchInformation formik={formik} branch={BRANCH_TYPE.ENERGY} />
        ) : null}
        {formik.values.isGasActive ? (
          <NEBranchInformation formik={formik} branch={BRANCH_TYPE.GAS} />
        ) : null}
      </div>
      <FFormDebug values={formik.values} errors={formik.errors} />
      <div className="ne-form__action-buttons">
        <FormActionButtons
          hasErrors={Object.keys(formik.errors).length > 0}
          titleLeft="Zurück"
          titleRight={activeStep === NE_ACTIVE_STEP.FORM_UPLOAD ? 'Antrag einreichen' : 'Weiter'}
          onClickLeft={onBack}
          onClickRight={onSubmit}
          errorMessage={getErrorMessage()}
        />
      </div>
    </>
  );
};
